import { getGtmContentGroup } from '~/utils/getGtmContentGroup'
import { useIsSubdomain } from '~/composables/useSubdomain'

export default defineNuxtRouteMiddleware((to, from) => {
  if (process.server) return

  const {
    public: { baseUrl },
  } = useRuntimeConfig()
  const gtm = useKftGtm()
  const excludedRoutes = ['/embedded/', '/ping/', '/widgets/']
  const { isEmbedded } = useEmbeddedCheckout()
  const isSubdomain = useIsSubdomain()

  const shouldEnableGtm =
    gtm &&
    gtm.enable &&
    !isEmbedded.value &&
    !excludedRoutes.some((x) => to.path.match(x)) &&
    !isSubdomain.value

  if (!shouldEnableGtm) return

  gtm.enable()

  // Skip if staying on the same page (not initial load)
  if (from.name && to.path === from.path) return

  // Skip if this is initial load and route is not fully resolved yet
  // (routeName will be undefined if i18n hasn't processed the route)
  if (!from.name && !to.name) return

  setTimeout(() => {
    const pageTitle =
      typeof document !== 'undefined' ? document?.title || '' : ''
    gtm.pushToDataLayer({
      routeName: to.name,
      content_group: getGtmContentGroup(to),
      pageType: 'PageView',
      pageUrl: baseUrl + to.fullPath,
      pagePath: to.fullPath,
      pageTitle,
      event: 'nuxtRoute',
    })
  }, 2000)
})
